import React, {useEffect, useRef, useState} from 'react';
import {
    ButtonPedidos,
    ContainerLeft,
    ContainerPrecios,
    ContainerRight,
    EtiquetaPrecio,
    EtiquetasPedido,
    Longcard,
    OrdenPedido,
    Precios,
    PreciosDiv,
    PreciosPedidoEtiqueta,
    ViewCart,
    formatEuro
} from '../../user/ui/cuenta.elements';
import 'react-toastify/dist/ReactToastify.css';
import {ContainerPDF, Indicador, ParrafoIndicador} from '../../ui';
import {DownloadableOrderRecap} from './DownloadableOrderRecap';
import {useTenantContext} from '../../tenant/TenantContext';
import {downloadCmpAsPdf} from '../../helpers/downloadBlob';
import {ProductsModal} from '../../product';
import {getAll} from '../infrastructure/OrderApi';

function OrderHistory() {
    const tenant = useTenantContext();
    const { primaryColor, secondaryColor } = tenant;
    const [orders, setOrders] = useState([]);
    const [orderData, setOrderData] = useState();
    const [showModals, setShowModals] = useState({});

    const GetOrders = async () => {
        try {
            setOrders(await getAll());
        } catch (error) {
            alert('Error al cargar historial de pedidos');
        }
    };

    const certificateTemplateRef = useRef(null);

    const downloadOrdersPdf = async (order) => {
        setOrderData(order);
        await downloadCmpAsPdf(certificateTemplateRef, `order-${order.numOrden}`);
    };

    useEffect(() => {
        GetOrders().catch(error => console.log(error));
    }, []);

    return (
        <div className="d-flex flex-column gap-5">
            <div>
                <Indicador indicador={'Historial de pedidos'} />
                <ParrafoIndicador
                    parrafo={'Revisa el historial de tus pedidos, su estado y descarga tus pedidos.'} />
                <div className="row">
                    {orders.map((pedido, index) => (
                        <Longcard className="col-md-12" key={index}>
                            <div className="row">
                                <ContainerLeft className="col-md-6">
                                    <EtiquetasPedido>Fecha de pedido</EtiquetasPedido>
                                    <EtiquetaPrecio background={secondaryColor}>{pedido.fechaPedido}</EtiquetaPrecio>
                                    <OrdenPedido>Numero de pedido: {pedido.numOrden}</OrdenPedido>
                                    {/* Envios del pedido (albaranes de BC): salen cuando el almacen
                                        expide; con agencia via Sendcloud llevan enlace de seguimiento. */}
                                    {(pedido.envios || []).map(envio => (
                                        <div key={envio.albaran} className="mt-1 d-flex align-items-center flex-wrap gap-2">
                                            <EtiquetaPrecio background={primaryColor}>
                                                🚚 {envio.estado || 'Enviado'}{envio.fecha ? ` · ${envio.fecha}` : ''}
                                            </EtiquetaPrecio>
                                            {envio.trackingUrl ? (
                                                <a href={envio.trackingUrl} target="_blank" rel="noreferrer">
                                                    Seguir envío {envio.trackingNo ? `(${envio.trackingNo})` : ''}
                                                </a>
                                            ) : envio.trackingNo ? (
                                                <span>Expedición {envio.trackingNo}</span>
                                            ) : null}
                                        </div>
                                    ))}
                                </ContainerLeft>
                                <ContainerRight className="col-md-6">
                                    <ViewCart
                                        color={primaryColor}
                                        onClick={() => setShowModals({
                                            ...showModals,
                                            [pedido.id]: !showModals[pedido.id]
                                        })}>
                                        {pedido.unidades} productos en este pedido
                                    </ViewCart>
                                    {showModals[pedido.id] && (
                                        <ProductsModal
                                            title={`Productos - Pedido ${pedido.numOrden}`}
                                            onModalClose={() => setShowModals({
                                                ...showModals,
                                                [pedido.id]: !showModals[pedido.id]
                                            })}
                                            products={pedido.articulos} />
                                    )}
                                    <div className="row">
                                        <div className="col-md-12">
                                            <ButtonPedidos
                                                text
                                                background={primaryColor}
                                                onClick={() => downloadOrdersPdf(pedido)}>
                                                Descargar pedido
                                            </ButtonPedidos>
                                        </div>
                                    </div>
                                    <ContainerPrecios>
                                        <PreciosDiv />
                                        <PreciosDiv>
                                            <PreciosPedidoEtiqueta>Descuentos</PreciosPedidoEtiqueta>
                                            <Precios background={primaryColor}>{formatEuro(pedido.descuentos)}</Precios>
                                        </PreciosDiv>
                                        <PreciosDiv>
                                            <PreciosPedidoEtiqueta>Subtotal</PreciosPedidoEtiqueta>
                                            <Precios>{formatEuro(pedido.subtotal)}</Precios>
                                        </PreciosDiv>
                                        <PreciosDiv>
                                            <PreciosPedidoEtiqueta>IVA</PreciosPedidoEtiqueta>
                                            <Precios>{formatEuro(pedido.iva)}</Precios>
                                        </PreciosDiv>
                                        <PreciosDiv>
                                            <PreciosPedidoEtiqueta>Total</PreciosPedidoEtiqueta>
                                            <Precios>{formatEuro(pedido.precioTotal)}</Precios>
                                        </PreciosDiv>
                                    </ContainerPrecios>
                                </ContainerRight>
                            </div>
                        </Longcard>
                    ))}
                </div>
                <ContainerPDF ref={certificateTemplateRef}>
                    <DownloadableOrderRecap order={orderData} />
                </ContainerPDF>
            </div>
        </div>
    );
}

export {OrderHistory};
